
export default function LanguageTag(props) {
    return (
        <div style = {{width: 'max-content', paddingLeft: '10px', paddingRight: '10px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: 'black', borderStyle: 'solid', borderWidth: '1px', borderColor: '#494949', borderRadius: '7px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <p style = {{color: 'white', fontSize: '12px'}}>{props.lang}</p>
        </div>
    )
}